import sqlFormatter from 'sql-formatter-plus';

const liquidForm = /{%\s*form\s*%}[^]*?{%\s*endform\s*%}/gm;
const liquidTagOrBlock = /{{{[^]*?}}}|{{[^]*?}}|{%[^]*?%}/gm;
const liquidTagOwnLine = /^( +)({%[^]*?%})/gm;
const nonHexChars = /[^0-9a-f]/gi;
const random = Math.random;

export function identity() {
  let base = random();
  while (base === 0) base = random() * 1e20;
  return `i` + base.toString(16).replace(nonHexChars, '');
}

export function createRef(comment = true, ident = identity) {
  if (comment) {
    return `/*__` + ident() + `__*/`;
  } else {
    return ident();
  }
}

export function isTag(value: string) {
  return value.startsWith('{%');
}

export function stripLiquid(query: string, ident = identity) {
  const replacers: ((query: string) => string)[] = [];

  // strip forms
  let source = query.replace(liquidForm, function (form) {
    replacers.push((query) => query + form);
    return '';
  });

  // strip rest of liquid tags/blocks
  source = source.replace(liquidTagOrBlock, function (expr) {
    const ref = createRef(isTag(expr), ident);
    replacers.push((query) => query.replace(ref, expr));
    return ref;
  });

  return {
    source,
    reinject(query: string) {
      return replacers.length === 0
        ? query
        : replacers
            .reduce((query, reducer) => reducer(query), query)
            // de-indent tags on their own line
            .replace(liquidTagOwnLine, '$2')
            // space out the forms
            .replace(liquidForm, '\n\n$&')
            // trim leading/trailing whitespace
            .trim();
    },
  };
}

export interface FormatQueryOptions {
  indent?: string;
  uppercase?: boolean;
  linesBetweenQueries?: number;
}

const defaultOptions: FormatQueryOptions = {
  indent: '  ',
  uppercase: true,
  linesBetweenQueries: 2,
};

export function formatQuery(query: string, options: FormatQueryOptions = {}) {
  const config = Object.assign({}, defaultOptions, options);
  const { source, reinject } = stripLiquid(query);
  const formatted = sqlFormatter.format(source, config);
  return reinject(formatted);
}
